import type { AxiosResponse } from "axios";
import { api } from "../../api_client";
import type { PaginatedResponse } from "../../pagination/data/types/pagination";
import type {
  ListPaymentsQueryDto,
  PayVendorBillDto,
  PaymentDto,
  UnpaidBillsQueryDto,
  VendorBillDto,
} from "./types";

const BASE = "/api/v1/admin/payments";

function buildQuery(query?: Record<string, unknown>): string {
  if (!query) return "";
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === "") continue;
    params.append(key, String(value));
  }
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export const adminPaymentsService = {
  listPayments(
    query: ListPaymentsQueryDto = {}
  ): Promise<AxiosResponse<PaginatedResponse<PaymentDto>>> {
    return api.get<PaginatedResponse<PaymentDto>>(
      `${BASE}${buildQuery(query as Record<string, unknown>)}`
    );
  },

  getPayment(id: number): Promise<AxiosResponse<PaymentDto>> {
    return api.get<PaymentDto>(`${BASE}/${id}`);
  },

  listSupplierUnpaidBills(
    supplierId: number,
    query: UnpaidBillsQueryDto = {}
  ): Promise<AxiosResponse<PaginatedResponse<VendorBillDto>>> {
    return api.get<PaginatedResponse<VendorBillDto>>(
      `${BASE}/suppliers/${supplierId}/unpaid-bills${buildQuery(query as Record<string, unknown>)}`
    );
  },

  payVendorBill(dto: PayVendorBillDto): Promise<AxiosResponse<PaymentDto>> {
    return api.post<PaymentDto>(`${BASE}/vendor-bills/pay`, dto);
  },

  getStats(): Promise<AxiosResponse<AdminPaymentStatsDto>> {
    return api.get<AdminPaymentStatsDto>(`${BASE}/stats`);
  },
};

export interface AdminPaymentStatsDto {
  totalRevenue: number;
  procurtalMargin: number | null;
  payoutsOutstanding: number;
  released: number;
  profit: number;
}
